import React from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const ProClientHistory = ({formModel})=>{    
    return <div>
         <DataTable value={formModel}>
            <Column field="dateTime" header="Date&Time"></Column>
            <Column field="activity" header="Activity"></Column>
            <Column field="location" header="Location"></Column>
            <Column field="building" header="Building"></Column>
            <Column field="intermediate" header="Intermediate"></Column>
            {/* <Column field="floor" header="Floor"></Column>
            <Column field="unit" header="Unit"></Column>
            <Column field="wing" header="Wing"></Column> */}
            <Column field="room" header="Room"></Column>
            <Column field="bed" header="Bed"></Column>
            <Column field="assignedOrRemovedBy" header="Assigned/Removed By"></Column>
        </DataTable>

    </div>
}

export default ProClientHistory;